import { render, staticRenderFns } from "./SmsTab.vue?vue&type=template&id=f69f731c&"
import script from "./SmsTab.vue?vue&type=script&lang=js&"
export * from "./SmsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports